import { cn } from "@/lib/utils";

interface PathVerticalLinesProps {
  isFirstPath: boolean;
  isLastPath: boolean;
  isHidden?: boolean;
  isExpanded?: boolean;
}

export const PathVerticalLines = ({
  isFirstPath,
  isLastPath,
  isHidden = false,
  isExpanded = false,
}: PathVerticalLinesProps) => {
  return (
    <>
      {!isFirstPath && (
        <div
          className={cn(
            "absolute top-0 left-[31.5px] z-0 h-4 w-0 border-l border-zinc-300",
            isHidden && "border-dashed",
          )}
        />
      )}
      {(!isLastPath || isExpanded) && (
        <div
          className={cn(
            "absolute top-[31.5px] left-[31.5px] z-0 h-[calc(100%-32px)] w-0 border-l border-zinc-300",
            isHidden && "border-dashed",
          )}
        />
      )}
    </>
  );
};
